<template>
 <div>
   <div id="customer-profile-details" class="vx-row">
     <div class="vx-col w-full">
       <vs-tabs position="top" id="customer-profile-tabs" class="w-full">
         <vs-tab label="General">
           <ValidationObserver ref="form" v-slot="{ handleSubmit }">

             <form autocomplete="off">
               <vx-card :title="form.status ? form.status.name  : ''" :titleColor="customerStatusColorFactory(form.status_id)"
                        id="customer_profile" class="">
                 <template slot="actions">
                   <div class="dropdown-button-container w-16" v-if="form.status">
                     <!--            <vs-button color="primary" class="btnx" type="filled">Change Status</vs-button>-->
                     <vs-dropdown v-if="$canAny(customer_permissions)">
                       <a class="flex items-center" href="#">
                         Status
                         <i class="material-icons"> expand_more </i>
                       </a>
                       <vs-dropdown-menu class="w-64">
                         <vs-dropdown-item v-if="[1, 2, 3].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('subscriber')" :disabled="form.status.id === 1"> Subscriber</vs-dropdown-item>
                         <vs-dropdown-item v-if="[1, 2, 3].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('lead')" :disabled="form.status.id === 2"> Lead </vs-dropdown-item>
                         <vs-dropdown-item v-if="[1, 2, 3].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('opportunity')"  :disabled="form.status.id === 3"> Opportunity </vs-dropdown-item>
                         <vs-dropdown-item v-if="[1, 2, 3].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('pending-customer')"> Pending Customer </vs-dropdown-item>
                         <vs-dropdown-item v-if="[5, 6, 8, 9, 10, 11, 4, 12].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('approve')" class="text-success"> Approve Customer </vs-dropdown-item>
                         <vs-dropdown-item v-if="[5, 6, 4, 12].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('reject')" class="text-danger"> Reject Customer </vs-dropdown-item>
                         <vs-dropdown-item v-if="[7, 11].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('hold')" class="text-warning"> Put on hold </vs-dropdown-item>
<!--                         <vs-dropdown-item v-if="[7, 8, 9, 10, 11].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('suspend_level_1')" :disabled="form.status.id === 9" class="text-danger"> Suspend Level 1 Customer </vs-dropdown-item>-->
<!--                         <vs-dropdown-item v-if="[7, 8, 9, 10, 11].includes(form.status.id)" @click="customerStatusChangeConfirmDialog('suspend_level_2')" :disabled="form.status.id === 10" class="text-danger"> Suspend Level 2 Customer </vs-dropdown-item>-->
<!--                         <vs-dropdown-item v-if="[7, 8, 9, 10, 11, 12].includes(form.status.id)"-->
<!--                                           v-can="'suspend-customer'"-->
<!--                                           @click="customerStatusChangeConfirmDialog('suspend_level_3')"-->
<!--                                           :disabled="form.status.id === 11" class="text-danger"> Suspend Customer </vs-dropdown-item>-->

                       </vs-dropdown-menu>
                     </vs-dropdown>
                   </div>
                 </template>

                 <div class="flex flex-wrap items-center justify-end">
                   <vs-button v-if="$canAny(customer_permissions)"
                     @click.stop="onClickUpdateProfile" class="ml-auto mt-2">Save Changes</vs-button>
                 </div>

                 <div class="vx-row mb-3 mt-4">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                       <small class="label">Company Name</small>
                       <vs-input type="text" name="company_name" class="w-full" v-model="form.company_name"
                                 :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="parent_company_name" name="parent_company_name" rules="" v-slot="{ errors }">
                       <small class="label">Parent Company Name</small>
                       <vs-input type="text" name="parent_company_name" class="w-full" v-model="form.parent_company_name"
                                 :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                   </div>
                 </div>
                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="email" name="email" rules="email" v-slot="{ errors }">
                       <small class="label">Company General Email</small>
                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                 type="text" name="email" class="w-full" v-model="form.email"
                                 :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="alternative_email" name="alternative_email" rules="email" v-slot="{ errors }">
                       <small class="label">Alternate Company Email</small>
                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                 type="text" name="alternative_email" class="w-full" v-model="form.alternative_email"
                                 :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                     <!--            <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">-->
                     <!--              <small class="label">Country</small>-->
                     <!--              <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder="" label="name"-->
                     <!--                        v-model="form.country" :reduce="option => option.name" :options="countryCodes"-->
                     <!--                        :dir="$vs.rtl ? 'rtl' : 'ltr'">-->
                     <!--                <template v-slot:option="option">-->
                     <!--                  <span>{{option.name}} </span>-->
                     <!--                </template>-->
                     <!--              </v-select>-->
                     <!--              <span class="text-danger text-sm">{{ errors[0] }}</span>-->
                     <!--            </ValidationProvider>-->
                   </div>
                 </div>
                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <div class="vx-row">
                       <div class="vx-col w-1/3">
                         <ValidationProvider vid="country_code_main_telephone" name="country_code_main_telephone" rules="required"
                                             v-slot="{ errors }">
                           <small class="label">Country Code</small>
                           <v-select class="style-chooser" :filter-by="myFilter" :clearable="false" name="country_code_main_telephone" placeholder=""
                                     label="isd_code" v-model="form.country_code_main_telephone" :reduce="option => option.isd_code"
                                     :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                             <template v-slot:option="option">
                               <span>{{option.isd_code}} - {{option.name}} </span>
                             </template>
                           </v-select>
                           <span class="text-danger text-sm">{{ errors[0] }}</span>
                         </ValidationProvider>
                       </div>
                       <div class="vx-col w-2/3">
                         <ValidationProvider vid="main_telephone" name="main_telephone" rules="required|tel|max:15" v-slot="{ errors }">
                           <small class="label">Main Telephone</small>
                           <vs-input name="main_telephone" class="w-full required" label="" v-model="form.main_telephone"
                                     :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                     val-icon-pack="feather" :disabled="is_disabled_customer_fields"/>
                         </ValidationProvider>
                       </div>
                     </div>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <div class="vx-row">
                       <div class="vx-col w-1/3">
                         <ValidationProvider vid="country_code_secondary_telephone" name="country_code_secondary_telephone" rules="" v-slot="{ errors }">
                           <small class="label">Country Code</small>
                           <v-select :filter-by="myFilter" :clearable="false" name="country_code_secondary_telephone" placeholder=""
                                     label="isd_code" v-model="form.country_code_secondary_telephone" :reduce="option => option.isd_code"
                                     :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                             <template v-slot:option="option">
                               <span>{{option.isd_code}} - {{option.name}} </span>
                             </template>
                           </v-select>
                           <span class="text-danger text-sm">{{ errors[0] }}</span>
                         </ValidationProvider>
                       </div>
                       <div class="vx-col w-2/3">
                         <ValidationProvider vid="secondary_telephone" name="secondary_telephone" rules="" v-slot="{ errors }">
                           <small class="label">Secondary Telephone</small>
                           <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                     val-icon-pack="feather" type="text" name="secondary_telephone" class="w-full" v-model="form.secondary_telephone"
                                     :disabled="is_disabled_customer_fields"/>
                         </ValidationProvider>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <div class="vx-row">
                       <div class="vx-col w-1/3">
                         <ValidationProvider vid="country_code_fax" name="country_code_fax" rules="" v-slot="{ errors }">
                           <small class="label">Country Code</small>
                           <v-select :filter-by="myFilter" :clearable="false" name="country_code_fax" placeholder=""
                                     label="isd_code" v-model="form.country_code_fax" :reduce="option => option.isd_code"
                                     :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                             <template v-slot:option="option">
                               <span>{{option.isd_code}} - {{option.name}} </span>
                             </template>
                           </v-select>
                           <span class="text-danger text-sm">{{ errors[0] }}</span>
                         </ValidationProvider>
                       </div>
                       <div class="vx-col w-2/3">
                         <ValidationProvider vid="fax" name="fax" rules="" v-slot="{ errors }">
                           <small class="label">Fax</small>
                           <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                     val-icon-pack="feather" type="text" name="fax" class="w-full" v-model="form.fax"
                                     :disabled="is_disabled_customer_fields"/>
                         </ValidationProvider>
                       </div>
                     </div>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider vid="ukims" name="ukims" rules="" v-slot="{ errors }">
                          <small class="label">UKIMS Number</small>
                          <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                     val-icon-pack="feather" type="text" name="fax" class="w-full" v-model="form.ukims"
                                     :disabled="is_disabled_customer_fields"/>
                      </ValidationProvider>
                    </div>
                 </div>

                 <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="source" name="source" rules="" v-slot="{ errors }">
                                <small class="label">Source</small>
                                <v-select multiple v-on:input="onChangeCustomerSource" :clearable="false"
                                    :closeOnSelect="false" name="industry_sector" placeholder="" label="name"
                                    v-model="form.source" :reduce="option => option.id" :options="customerSources"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                </v-select>

                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="sub_source" name="sub_source" rules="" v-slot="{ errors }">
                                <small class="label">Sub Source</small>
                                <v-select multiple :clearable="false" :closeOnSelect="false" name="sub_source"
                                    placeholder="" label="name" v-model="form.sub_source" :reduce="option => option.id"
                                    :options="customerSubSources" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        Please select Industry Sector first!
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider  vid="industry_sector" name="industry_sector" rules="" v-slot="{ errors }">
                       <small class="label">Industry Sector</small>
                       <v-select multiple v-on:input="onChangeIndustrySector" :clearable="false" :closeOnSelect="false" name="industry_sector" placeholder="" label="name"
                                 v-model="form.industry_sector"
                                 :reduce="option => option.id"
                                 :options="industrySectors"
                                 :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                         <template v-slot:option="option">
                           <span>{{option.name}} </span>
                         </template>
                       </v-select>

                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="industry_sub_sector" name="industry_sub_sector" rules="" v-slot="{ errors }">
                       <small class="label">Industry Sub Sector</small>
                       <v-select multiple :clearable="false" :closeOnSelect="false" name="industry_sub_sector" placeholder="" label="name"
                                 v-model="form.industry_sub_sector" :reduce="option => option.id" :options="industrySubSectors" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                 :disabled="is_disabled_customer_fields">
                         <template v-slot:option="option">
                           <span>{{option.name}} </span>
                         </template>
                         <template #no-options="{ search, searching, loading }">
                           Please select Industry Sector first!
                         </template>
                       </v-select>
                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                 </div>
                 
                 <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/3 w-full md:mb-0" v-for="(pack_size, pack_size_index) in form.pack_sizes" :key="pack_size_index">
                     <ValidationProvider vid="pack_size" name="pack_size" rules="" v-slot="{ errors }">
                       <small class="label">Pack Size in Kg ({{ pack_size.formulation_type }})</small>
                       <!-- <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                 type="text" name="pack_size" class="w-full" v-model="pack_size.size" :disabled="is_disabled_customer_fields"/> -->
                                 <v-select :clearable="true" name="pack_size" placeholder="" v-model="pack_size.size" :options="pack_size_options" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                          :disabled="is_disabled_customer_fields" label="size" :reduce="option => option.size"/>
                     </ValidationProvider>
                   </div>
                 </div>

                 <!--        social account section start-->
                 <!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Social Accounts</vs-divider>-->
                 <vx-card titleColor="#736F6E" title="Social Accounts" class="my-8" no-shadow>
                   <vs-row vs-w="12" class="mt-8">
                     <vs-col v-for="(social, index_contact) in form.social_accounts" :key="index_contact"
                             vs-type="flex"
                             vs-justify="center"
                             vs-align="center"
                             vs-lg="6" vs-sm="6" vs-xs="12"
                             class="px-4 pb-4">
                       <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteSocialAccount(index_contact)" :remove-card-action="!is_disabled_customer_fields"  :collapse-action="false">
                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_contact+'type'" :name="index_contact+'type'" rules="required" v-slot="{ errors }">
                               <small class="label">Type</small>
                               <v-select  :clearable="false" name="type" placeholder="" v-model="social.type" :options="socialMediaList" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                          :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_contact+'url'" :name="index_contact+'url'" rules="required" v-slot="{ errors }">
                               <small class="label">URL</small>
                               <vs-input type="text" v-model="social.url" name="url" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                       </vx-card-custom>
                     </vs-col>
                   </vs-row>
                   <vs-button class="mt-4 mb-4 ml-4" @click="addSocialAccount" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus"
                              :disabled="is_disabled_customer_fields">Add social account</vs-button>
                 </vx-card>
                 <!--        social account section end-->

                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="background_info" name="background_info" rules="" v-slot="{ errors }">
                       <small class="label">Background Info</small>
                       <vs-textarea class="mb-0" v-model="form.background_info" height="100px" :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="value_added_activities" name="value_added_activities" rules="" v-slot="{ errors }">
                       <small class="label">Value Added Activities</small>
                       <vs-textarea class="mb-0" v-model="form.value_added_activities" height="100px" :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                 </div>

                 <div class="vx-row mb-3">
                  <!-- import_licence_no -->
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="import_licence_no" name="import_licence_no" rules="" v-slot="{ errors }">
                       <small class="label">Import Licence No</small>
                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                 val-icon-pack="feather" type="text" name="import_licence_no" class="w-full" v-model="form.import_licence_no"
                                 :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="initial_enquiry" name="initial_enquiry" rules="" v-slot="{ errors }">
                       <small class="label">Initial Enquiry</small>
                       <vs-textarea class="mb-0" v-model="form.initial_enquiry" height="100px" :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                 </div>


                 <div class="vx-row mb-3 mt-4">
<!--                   <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                     <ValidationProvider vid="nature_of_business" name="nature_of_business" rules="" v-slot="{ errors }">-->
<!--                       <small class="label">Nature of Business</small>-->
<!--                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"-->
<!--                                 val-icon-pack="feather" type="text" name="nature_of_business" class="w-full" v-model="form.nature_of_business"/>-->
<!--                     </ValidationProvider>-->
<!--                   </div>-->
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="eori" name="eori" rules="" v-slot="{ errors }">
                       <small class="label">EORI Number </small>
                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                 val-icon-pack="feather" type="text" name="eori" class="w-full" v-model="form.eori"
                                 :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="website" name="website" rules="" v-slot="{ errors }">
                       <small class="label">Web site</small>
                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                 type="text" name="email" class="w-full" v-model="form.website"
                                 :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                   </div>
                 </div>
                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="date_trade_commenced" name="date_trade_commenced" rules="required" v-slot="{ errors }">
                       <small class="label">Date Trade Commenced</small>
                       <!--              <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"-->
                       <!--                        val-icon-pack="feather" type="text" name="date_trade_commenced" class="w-full" v-model="form.date_trade_commenced"/>-->

                       <flat-pickr class="hidden" :config="{ dateFormat: 'd/m/Y'}" v-model="form.date_trade_commenced" placeholder="Choose Date"/>
                       <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y'}" v-model="form.date_trade_commenced" placeholder="Choose Date"
                                   :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="credit_required_per_month" name="credit_required_per_month" rules="required" v-slot="{ errors }">
                       <small class="label">Credit Required Per Month</small>
                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                 type="text" name="credit_required_per_month" class="w-full" v-model="form.credit_required_per_month"
                                 :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                   </div>
                 </div>
                 <div class="vx-row mb-3 mt-4 hidden">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="payment_terms" name="payment_terms" rules="" v-slot="{ errors }">
                       <small class="label">Payment Terms (Days)</small>
                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                 type="text" name="payment_terms" class="w-full" v-model="form.payment_terms"
                                 :disabled="is_disabled_customer_fields"/>
                    </ValidationProvider>
                  </div>
                 </div>
                 <div class="vx-row mb-3 mt-4">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="account_handler_id" name="account_handler_id" rules="" v-slot="{ errors }">
                       <small class="label">Account Handler</small>
                       <v-select  :clearable="false" name="account_handler_id" placeholder="" label="name" v-model="form.account_handler_id"
                                  :reduce="option => option.value" :options="account_handlers" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  :disabled="is_disabled_customer_fields">
                         <template v-slot:option="option">
                           <span>{{option.name}} </span>
                         </template>
                       </v-select>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="tss_registration_number" name="tss_registration_number" rules="" v-slot="{ errors }">
                       <small class="label">TSS Registration Number</small>
                       <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                 type="text" name="tss_registration_number" class="w-full" v-model="form.tss_registration_number"
                                 :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                   </div>
                 </div>

                 <div class="vx-row mb-3">
                   <div class="vx-col w-full">
                     <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                       <small class="label">Additional Information</small>
                       <vs-textarea class="mb-0" v-model="form.additional_information" height="100px"
                                    :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                 </div>

                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/5 md:mb-0">
                     <ValidationProvider vid="is_vat_registration" name="is_vat_registration" rules="" v-slot="{ errors }">
                       <small class="label">Do you have a Company VAT Registration?</small>
                       <vs-switch v-model="form.is_vat_registration" icon-pack="feather" vs-icon-on="icon-check-circle"
                                  vs-icon-off="icon-slash" class="mt-2 w-16" :disabled="is_disabled_customer_fields">
                         <span slot="on">Yes</span>
                         <span slot="off">No</span>
                       </vs-switch>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col w-2/5">
                     <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_country"
                                         name="is_vat_registration_country" rules="required" v-slot="{ errors }">
                       <small class="label">If Yes, In which country are you registered?</small>
                       <v-select :filter-by="myFilter" :clearable="false" name="is_vat_registration_country" placeholder=""
                                 label="name" v-model="form.is_vat_registration_country" :reduce="option => option.name"
                                 :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-2/5 w-full md:mb-0">
                     <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_text"
                                         name="is_vat_registration_text" rules="required" v-slot="{ errors }">
                       <small class="label">If Yes, Company VAT Registration?</small>
                       <vs-input type="text" name="is_vat_registration_text" class="w-full"
                                 v-model="form.is_vat_registration_text" :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                 </div>

                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/5 md:mb-0">
                     <ValidationProvider vid="is_registration" name="is_registration" rules="" v-slot="{ errors }">
                       <small class="label">Do you have a Company Registration Number?</small>
                       <vs-switch v-model="form.is_registration" icon-pack="feather" vs-icon-on="icon-check-circle"
                                  vs-icon-off="icon-slash" class="mt-2 w-16" :disabled="is_disabled_customer_fields">
                         <span slot="on">Yes</span>
                         <span slot="off">No</span>
                       </vs-switch>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col w-2/5">
                     <ValidationProvider v-if="form.is_registration" vid="is_registration_country" name="is_registration_country"
                                         rules="required" v-slot="{ errors }">
                       <small class="label">If Yes, In which country are you registered</small>
                       <v-select :filter-by="myFilter" :clearable="false" name="is_registration_country" placeholder=""
                                 label="name" v-model="form.is_registration_country" :reduce="option => option.name"
                                 :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-2/5 w-full md:mb-0">
                     <ValidationProvider v-if="form.is_registration" vid="is_registration_text" name="is_registration_text"
                                         rules="required" v-slot="{ errors }">
                       <small class="label">If Yes, Company Registration Number</small>
                       <vs-input type="text" name="is_registration_text" class="w-full" v-model="form.is_registration_text"
                                 :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                 </div>


                 <!--        contacts section start-->
                 <vx-card titleColor="#736F6E" title="Contacts" class="my-8 hidden" no-shadow>
                   <vs-row vs-w="12" class="mt-8">
                     <vs-col v-for="(contact, index_contact) in form.contacts" :key="index_contact"
                             vs-type="flex"
                             vs-justify="center"
                             vs-align="center"
                             vs-lg="6" vs-sm="6" vs-xs="12"
                             class="px-4 pb-4">
                       <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteContact(index_contact)" :remove-card-action="![0].includes(index_contact) && !is_disabled_customer_fields"  :collapse-action="false">

                         <vs-button class="mt-2 mb-2 mr-2 ml-auto" v-if="!isExsistInUsers(contact.email) && contact.id" @click="addToUsers(contact)" size="small" color="warning" type="filled">
                           Add to users
                         </vs-button>

                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-full w-full md:mb-0">
                             <ValidationProvider :vid="index_contact+'type'" :name="index_contact+'type'" rules="required" v-slot="{ errors }">
                               <small class="label">Contact Type</small>
                               <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="contact.type"
                                         :reduce="option => option.value" :options="contacts_types" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                                 <template v-slot:option="option">
                                   <span>{{option.name}} </span>
                                 </template>
                               </v-select>
                               <span class="text-danger text-sm">{{ errors[0] }}</span>
                             </ValidationProvider>
                           </div>
                         </div>


                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_contact+'contact_name'" :name="index_contact+'contact_name'" rules="required" v-slot="{ errors }">
                               <small class="label">Contact Name</small>
                               <vs-input type="text" v-model="contact.contact_name" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_contact+'email'" :name="index_contact+'email'" rules="required|email" v-slot="{ errors }">
                               <small class="label">Contact Email</small>
                               <vs-input type="text" v-model="contact.email" name="email" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider :vid="index_contact+'country_code_telephone'" :name="index_contact+'country_code_telephone'" rules="required" v-slot="{ errors }">
                               <small class="label">Country Code</small>
                               <v-select :filter-by="myFilter" :clearable="false" name="country_code_telephone" placeholder=""
                                         label="isd_code" v-model="contact.country_code_telephone" :reduce="option => option.isd_code"
                                         :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                                 <template v-slot:option="option">
                                   <span>{{option.isd_code}} - {{option.name}} </span>
                                 </template>
                               </v-select>
                               <span class="text-danger text-sm">{{ errors[0] }}</span>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider :vid="index_contact+'telephone'" :name="index_contact+'telephone'" rules="required" v-slot="{ errors }">
                               <small class="label">Telephone</small>
                               <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                         val-icon-pack="feather" type="text" name="telephone" class="w-full" v-model="contact.telephone"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                       </vx-card-custom>
                     </vs-col>
                   </vs-row>
                   <vs-button class="mt-4 mb-4 ml-4" @click="addContact" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus"
                              :disabled="is_disabled_customer_fields">Add new contact</vs-button>
                 </vx-card>
                 <!--        contacts section end-->



                 <!--        main address section start-->
                 <!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Main Address</vs-divider>-->
                 <vx-card titleColor="#736F6E" title="Main Address" class="my-8" no-shadow>
                   <vs-row vs-w="12" class="mt-8">
                     <vs-col v-for="(address, index_address) in form.addresses" :key="index_address"
                             vs-type="flex"
                             vs-justify="center"
                             vs-align="center"
                             vs-lg="6" vs-sm="6" vs-xs="12"
                             class="px-4 pb-4">
                       <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteMainAddresses(index_address)"  :collapse-action="false">

                         <!--                TODO GOOGLE MAP SEARCH AUTOCOMPLETE-->
                         <!--                <gmap-autocomplete @place_changed="setPlace($event, index_address)" class="introInput" >-->
                         <!--                  <template v-slot:input="slotProps">-->
                         <!--                    <div class="vx-row mb-2 w-full">-->
                         <!--                      <div class="vx-col md:w-full w-full md:mb-0">-->
                         <!--                        <small class="label">Search</small>-->
                         <!--                        <vs-input class="w-full" size="small" ref="input"-->
                         <!--                                  v-on:listeners="slotProps.listeners"-->
                         <!--                                  v-on:attrs="slotProps.attrs" />-->
                         <!--                      </div>-->
                         <!--                    </div>-->
                         <!--                  </template>-->
                         <!--                </gmap-autocomplete>-->

                         <div class="vx-row mb-2 w-full">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'line1'" :name="index_address+'line1'" rules="required" v-slot="{ errors }">
                               <small class="label">Address Line 1</small>
                               <vs-input type="text" v-model="address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'line2'" :name="index_address+'line2'" rules="" v-slot="{ errors }">
                               <small class="label">Address Line 2</small>
                               <vs-input type="text" v-model="address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2 w-full">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'line3'" :name="index_address+'line3'" rules="" v-slot="{ errors }">
                               <small class="label">Address Line 3</small>
                               <vs-input type="text" v-model="address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'town_state'" :name="index_address+'town_state'" rules="required" v-slot="{ errors }">
                               <small class="label">Name of Town / State</small>
                               <vs-input type="text" v-model="address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2 w-full">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'post_code'" :name="index_address+'post_code'" rules="required" v-slot="{ errors }">
                               <small class="label">Postal code</small>
                               <vs-input type="text" v-model="address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider :vid="index_address+'country'" :name="index_address+'country'" rules="required" v-slot="{ errors }">
                               <small class="label">Country</small>
                               <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                         :disabled="is_disabled_customer_fields">
                                 <template v-slot:option="option">
                                   <span>{{option.name}} </span>
                                 </template>
                               </v-select>
                               <span class="text-danger text-sm">{{ errors[0] }}</span>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2 w-full">
                           <div class="vx-col md:w-full w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'note'" :name="index_address+'note'" rules="" v-slot="{ errors }">
                               <small class="label">Any Note</small>
                               <vs-input type="text" v-model="address.note" name="note" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                       </vx-card-custom>
                     </vs-col>
                   </vs-row>
                   <!--          <vs-button class="mt-4 mb-4 ml-4" @click="addMainAddress" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new address</vs-button>-->
                 </vx-card>
                 <!--        main address section end-->

                 <!--        delivery address section start-->
                 <!--        <vs-divider v-if="!form.delivery_address_same_as_above" class="mt-8 mb-12" color="primary" position="center">Delivery Address</vs-divider>-->

<!--                 <vx-card  titleColor="#736F6E" title="Delivery Address" class="my-8" no-shadow>-->
<!--                   <div class="vx-row mb-3 mt-4">-->
<!--                     <div class="vx-col md:w-full md:mb-0">-->
<!--                       <ValidationProvider vid="invoice_address_same_as_above" name="invoice_address_same_as_above" rules="" v-slot="{ errors }">-->
<!--                         <small class="label">Is Delivery Address Same as Above?</small>-->
<!--                         <vs-switch v-model="form.delivery_address_same_as_above" icon-pack="feather" vs-icon-on="icon-check-circle"-->
<!--                                    vs-icon-off="icon-slash" class="mt-2 w-16">-->
<!--                           <span slot="on">Yes</span>-->
<!--                           <span slot="off">No</span>-->
<!--                         </vs-switch>-->
<!--                       </ValidationProvider>-->
<!--                     </div>-->
<!--                   </div>-->


<!--                   <vs-row v-if="!form.delivery_address_same_as_above"  vs-w="12" class="mt-8">-->
<!--                     <vs-col v-for="(address, index_address) in form.delivery_address" :key="index_address"-->
<!--                             vs-type="flex"-->
<!--                             vs-justify="center"-->
<!--                             vs-align="center"-->
<!--                             vs-lg="6" vs-sm="6" vs-xs="12"-->
<!--                             class="px-4 pb-4">-->
<!--                       <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteDeliveryAddresses(index_address)" :remove-card-action="form.delivery_address.length !== 1"  :collapse-action="false">-->
<!--                         <div class="vx-row mb-2 w-full">-->
<!--                           <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                             <ValidationProvider  :vid="index_address+'delivery_address_line1'" :name="index_address+'delivery_address_line1'" rules="required" v-slot="{ errors }">-->
<!--                               <small class="label">Address Line 1</small>-->
<!--                               <vs-input type="text" v-model="address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--                             </ValidationProvider>-->
<!--                           </div>-->
<!--                           <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                             <ValidationProvider  :vid="index_address+'delivery_address_line2'" :name="index_address+'delivery_address_line2'" rules="" v-slot="{ errors }">-->
<!--                               <small class="label">Address Line 2</small>-->
<!--                               <vs-input type="text" v-model="address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--                             </ValidationProvider>-->
<!--                           </div>-->
<!--                         </div>-->

<!--                         <div class="vx-row mb-2 w-full">-->
<!--                           <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                             <ValidationProvider  :vid="index_address+'delivery_address_line3'" :name="index_address+'delivery_address_line3'" rules="" v-slot="{ errors }">-->
<!--                               <small class="label">Address Line 3</small>-->
<!--                               <vs-input type="text" v-model="address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--                             </ValidationProvider>-->
<!--                           </div>-->
<!--                           <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                             <ValidationProvider  :vid="index_address+'delivery_address_town_state'" :name="index_address+'delivery_address_town_state'" rules="required" v-slot="{ errors }">-->
<!--                               <small class="label">Name of Town / State</small>-->
<!--                               <vs-input type="text" v-model="address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--                             </ValidationProvider>-->
<!--                           </div>-->
<!--                         </div>-->

<!--                         <div class="vx-row mb-2 w-full">-->
<!--                           <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                             <ValidationProvider  :vid="index_address+'delivery_address_post_code'" :name="index_address+'delivery_address_post_code'" rules="required" v-slot="{ errors }">-->
<!--                               <small class="label">Postal code</small>-->
<!--                               <vs-input type="text" v-model="address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--                             </ValidationProvider>-->
<!--                           </div>-->
<!--                           <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--                             <ValidationProvider :vid="index_address+'delivery_address_country'" :name="index_address + 'delivery_address_country'" rules="required" v-slot="{ errors }">-->
<!--                               <small class="label">Country</small>-->
<!--                               <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">-->
<!--                                 <template v-slot:option="option">-->
<!--                                   <span>{{option.name}} </span>-->
<!--                                 </template>-->
<!--                               </v-select>-->
<!--                               <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--                             </ValidationProvider>-->
<!--                           </div>-->
<!--                         </div>-->

<!--                         <div class="vx-row mb-2 w-full">-->
<!--                           <div class="vx-col md:w-full w-full md:mb-0">-->
<!--                             <ValidationProvider  :vid="index_address+'delivery_address_note'" :name="index_address+'delivery_address_note'" rules="" v-slot="{ errors }">-->
<!--                               <small class="label">Any Note</small>-->
<!--                               <vs-input type="text" v-model="address.note" name="note" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--                             </ValidationProvider>-->
<!--                           </div>-->
<!--                         </div>-->

<!--                       </vx-card-custom>-->
<!--                     </vs-col>-->
<!--                   </vs-row>-->
<!--                   <vs-button v-if="!form.delivery_address_same_as_above"  class="mt-4 mb-4 ml-4" @click="addDeliveryAddress" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add new address</vs-button>-->
<!--                 </vx-card>-->

                 <vx-card  titleColor="#736F6E" title="Invoice Address" class="my-8" no-shadow>
                   <div class="vx-row mb-3 mt-4">
                     <div class="vx-col md:w-full md:mb-0">
                       <ValidationProvider vid="invoice_address_same_as_above" name="invoice_address_same_as_above" rules="" v-slot="{ errors }">
                         <small class="label">Is Invoice Address Same as Above?</small>
                         <vs-switch v-model="form.invoice_address_same_as_above" icon-pack="feather" vs-icon-on="icon-check-circle"
                                    vs-icon-off="icon-slash" class="mt-2 w-16" :disabled="is_disabled_customer_fields">
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                       </ValidationProvider>
                     </div>
                   </div>

                   <vs-row v-if="!form.invoice_address_same_as_above"  vs-w="12" class="mt-8">
                     <vs-col v-for="(address, index_address) in form.invoice_address" :key="index_address"
                             vs-type="flex"
                             vs-justify="center"
                             vs-align="center"
                             vs-lg="6" vs-sm="6" vs-xs="12"
                             class="px-4 pb-4">
                       <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteInvoiceAddresses(index_address)" :remove-card-action="form.invoice_address.length !== 1 || !is_disabled_customer_fields"  :collapse-action="false">
                         <div class="vx-row mb-2 w-full">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'invoice_address_line1'" :name="index_address+'invoice_address_line1'" rules="required" v-slot="{ errors }">
                               <small class="label">Address Line 1</small>
                               <vs-input type="text" v-model="address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'invoice_address_line2'" :name="index_address+'invoice_address_line2'" rules="" v-slot="{ errors }">
                               <small class="label">Address Line 2</small>
                               <vs-input type="text" v-model="address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2 w-full">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'invoice_address_line3'" :name="index_address+'invoice_address_line3'" rules="" v-slot="{ errors }">
                               <small class="label">Address Line 3</small>
                               <vs-input type="text" v-model="address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'invoice_address_town_state'" :name="index_address+'invoice_address_town_state'" rules="required" v-slot="{ errors }">
                               <small class="label">Name of Town / State</small>
                               <vs-input type="text" v-model="address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2 w-full">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'invoice_address_post_code'" :name="index_address+'invoice_address_post_code'" rules="required" v-slot="{ errors }">
                               <small class="label">Postal code</small>
                               <vs-input type="text" v-model="address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider :vid="index_address+'invoice_address_country'" :name="index_address + 'invoice_address_country'" rules="required" v-slot="{ errors }">
                               <small class="label">Country</small>
                               <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                         :disabled="is_disabled_customer_fields">
                                 <template v-slot:option="option">
                                   <span>{{option.name}} </span>
                                 </template>
                               </v-select>
                               <span class="text-danger text-sm">{{ errors[0] }}</span>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2 w-full">
                           <div class="vx-col md:w-full w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'invoice_address_note'" :name="index_address+'invoice_address_note'" rules="" v-slot="{ errors }">
                               <small class="label">Any Note</small>
                               <vs-input type="text" v-model="address.note" name="note" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                       </vx-card-custom>
                     </vs-col>
                   </vs-row>
                   <vs-button v-if="!form.invoice_address_same_as_above"  class="mt-4 mb-4 ml-4" @click="addInvoiceAddress" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus"
                              :disabled="is_disabled_customer_fields">Add new address</vs-button>
                 </vx-card>
                 <!--      invoice address section end-->

                 <div class="vx-row mb-3 mt-4">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="special_delivery_instruction" name="special_delivery_instruction" rules="" v-slot="{ errors }">
                       <small class="label">Special Delivery Instruction</small>
                       <vs-textarea  class="mb-0" v-model="form.special_delivery_instruction" :disabled="is_disabled_customer_fields" />
                       <span class="text-danger mt-0 text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="additional_information" name="additional_information" rules="" v-slot="{ errors }">
                       <small class="label">Additional Information</small>
                       <vs-textarea  class="mb-0" v-model="form.additional_information" :disabled="is_disabled_customer_fields"/>
                       <span class="text-danger mt-0 text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                 </div>

                 <!--        bank details section start-->
                 <vx-card class="my-8" no-shadow titleColor="#736F6E" title="Bank Reference">

                   <div class="vx-row mb-8">
                     <div class="vx-col md:w-1/2 w-full md:mb-0">
                       <ValidationProvider vid="bank" name="bank" rules="" v-slot="{ errors }">
                         <small class="label">Bank Name</small>
                         <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                   val-icon-pack="feather" type="text" name="bank" class="w-full" v-model="form.bank"
                                   :disabled="is_disabled_customer_fields"/>
                       </ValidationProvider>
                     </div>
                   </div>

                   <span>Bank Address</span>

                   <div class="vx-row mb-2 mt-4">
                     <div class="vx-col md:w-1/2 w-full md:mb-0">
                       <ValidationProvider  vid="bank_address_line1" name="bank_address_line1" rules="" v-slot="{ errors }">
                         <small class="label">Address Line 1</small>
                         <vs-input type="text" v-model="form.bank_address.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                   :disabled="is_disabled_customer_fields"/>
                       </ValidationProvider>
                     </div>
                     <div class="vx-col md:w-1/2 w-full md:mb-0">
                       <ValidationProvider  vid="bank_address_line2" name="bank_address_line2" rules="" v-slot="{ errors }">
                         <small class="label">Address Line 2</small>
                         <vs-input type="text" v-model="form.bank_address.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                   :disabled="is_disabled_customer_fields"/>
                       </ValidationProvider>
                     </div>
                   </div>

                   <div class="vx-row mb-2">
                     <div class="vx-col md:w-1/2 w-full md:mb-0">
                       <ValidationProvider  vid="bank_address_line3" name="bank_address_line3" rules="" v-slot="{ errors }">
                         <small class="label">Address Line 3</small>
                         <vs-input type="text" v-model="form.bank_address.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                   :disabled="is_disabled_customer_fields"/>
                       </ValidationProvider>
                     </div>
                     <div class="vx-col md:w-1/2 w-full md:mb-0">
                       <ValidationProvider  vid="bank_address_town_state" name="bank_address_town_state" rules="" v-slot="{ errors }">
                         <small class="label">Name of Town / State</small>
                         <vs-input type="text" v-model="form.bank_address.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                   :disabled="is_disabled_customer_fields"/>
                       </ValidationProvider>
                     </div>
                   </div>

                   <div class="vx-row mb-2">
                     <div class="vx-col md:w-1/2 w-full md:mb-0">
                       <ValidationProvider  vid="bank_address_post_code" name="bank_address_post_code" rules="" v-slot="{ errors }">
                         <small class="label">Postal code</small>
                         <vs-input type="text" v-model="form.bank_address.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                   :disabled="is_disabled_customer_fields"/>
                       </ValidationProvider>
                     </div>
                     <div class="vx-col md:w-1/2 w-full md:mb-0">
                       <ValidationProvider vid="bank_address_country" name="bank_address_country" rules="" v-slot="{ errors }">
                         <small class="label">Country</small>
                         <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="form.bank_address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                   :disabled="is_disabled_customer_fields">
                           <template v-slot:option="option">
                             <span>{{option.name}} </span>
                           </template>
                         </v-select>
                         <span class="text-danger text-sm">{{ errors[0] }}</span>
                       </ValidationProvider>
                     </div>
                   </div>
                 </vx-card>
                 <!--        bank details section end-->

                 <div class="vx-row mb-2">
                   <div class="vx-col md:w-1/2 w-full md:mb-0">
                     <ValidationProvider vid="type_of_company" name="type_of_company" rules="required" v-slot="{ errors }">
                       <small class="label">Type of Company</small>
                       <v-select :filter-by="myFilter"  :clearable="false" name="type_of_company" placeholder="" label="name" v-model="form.type_of_company" :reduce="option => option.value" :options="company_types" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                 :disabled="is_disabled_customer_fields">
                         <template v-slot:option="option">
                           <span>{{option.name}} </span>
                         </template>
                       </v-select>
                       <span class="text-danger text-sm">{{ errors[0] }}</span>
                     </ValidationProvider>
                   </div>
                 </div>

                 <!--        solo partnership section start-->
                 <vs-row v-if="['sole_trader', 'partnership'].includes(form.type_of_company)" vs-w="12" class="mt-8">
                   <vs-col v-for="(sole, index_address) in form.sole_partnerships" :key="index_address"
                           vs-type="flex"
                           vs-justify="center"
                           vs-align="center"
                           vs-lg="6" vs-sm="6" vs-xs="12"
                           class="px-4 pb-4">
                     <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteSolePartnership(index_address)" :remove-card-action="form.sole_partnerships.length !== 1 || !is_disabled_customer_fields"  :collapse-action="false">

                       <div class="vx-row mb-2">
                         <div class="vx-col md:w-full w-full md:mb-0">
                           <ValidationProvider  :vid="index_address+'sole_full_name'" :name="index_address+'sole_full_name'" rules="" v-slot="{ errors }">
                             <small class="label">{{form.type_of_company === 'partnership' ? "Partner\'s name" : "Sole trader\'s name"}}</small>
                             <vs-input type="text" v-model="sole.full_name" name="full_name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                       :disabled="is_disabled_customer_fields"/>
                           </ValidationProvider>
                         </div>
                       </div>

                       <div class="vx-row mb-2">
                         <div class="vx-col md:w-1/2 w-full md:mb-0">
                           <ValidationProvider :vid="index_address+'sole_country_code_telephone'" :name="index_address+'sole_country_code_telephone'" rules="" v-slot="{ errors }">
                             <small class="label">Country Code</small>
                             <v-select :filter-by="myFilter" :clearable="false" name="country_code_telephone" placeholder=""
                                       label="isd_code" v-model="sole.country_code_telephone" :reduce="option => option.isd_code"
                                       :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="is_disabled_customer_fields">
                               <template v-slot:option="option">
                                 <span>{{option.isd_code}} - {{option.name}} </span>
                               </template>
                             </v-select>
                             <span class="text-danger text-sm">{{ errors[0] }}</span>
                           </ValidationProvider>
                         </div>
                         <div class="vx-col md:w-1/2 w-full md:mb-0">
                           <ValidationProvider :vid="index_address+'sole_telephone'" :name="index_address+'sole_telephone'" rules="" v-slot="{ errors }">
                             <small class="label">Telephone</small>
                             <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                       val-icon-pack="feather" type="text" name="telephone" class="w-full" v-model="sole.telephone" :disabled="is_disabled_customer_fields"/>
                           </ValidationProvider>
                         </div>
                       </div>

                       <div class="vx-row mb-2">
                         <div class="vx-col md:w-1/2 w-full md:mb-0">
                           <ValidationProvider  :vid="index_address+'sole_line1'" :name="index_address+'sole_line1'" rules="" v-slot="{ errors }">
                             <small class="label">Address Line 1</small>
                             <vs-input type="text" v-model="sole.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                       :disabled="is_disabled_customer_fields"/>
                           </ValidationProvider>
                         </div>
                         <div class="vx-col md:w-1/2 w-full md:mb-0">
                           <ValidationProvider  :vid="index_address+'sole_line2'" :name="index_address+'sole_line2'" rules="" v-slot="{ errors }">
                             <small class="label">Address Line 2</small>
                             <vs-input type="text" v-model="sole.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                       :disabled="is_disabled_customer_fields"/>
                           </ValidationProvider>
                         </div>
                       </div>

                       <div class="vx-row mb-2">
                         <div class="vx-col md:w-1/2 w-full md:mb-0">
                           <ValidationProvider  :vid="index_address+'sole_line3'" :name="index_address+'sole_line3'" rules="" v-slot="{ errors }">
                             <small class="label">Address Line 3</small>
                             <vs-input type="text" v-model="sole.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                       :disabled="is_disabled_customer_fields"/>
                           </ValidationProvider>
                         </div>
                         <div class="vx-col md:w-1/2 w-full md:mb-0">
                           <ValidationProvider  :vid="index_address+'sole_town_state'" :name="index_address+'sole_town_state'" rules="" v-slot="{ errors }">
                             <small class="label">Name of Town / State</small>
                             <vs-input type="text" v-model="sole.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                       :disabled="is_disabled_customer_fields"/>
                           </ValidationProvider>
                         </div>
                       </div>

                       <div class="vx-row mb-2">
                         <div class="vx-col md:w-1/2 w-full md:mb-0">
                           <ValidationProvider  :vid="index_address+'sole_post_code'" :name="index_address+'sole_post_code'" rules="" v-slot="{ errors }">
                             <small class="label">Postal code</small>
                             <vs-input type="text" v-model="sole.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                       :disabled="is_disabled_customer_fields"/>
                           </ValidationProvider>
                         </div>
                         <div class="vx-col md:w-1/2 w-full md:mb-0">
                           <ValidationProvider :vid="index_address+'sole_country'" :name="index_address+'sole_country'" rules="" v-slot="{ errors }">
                             <small class="label">Country</small>
                             <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="sole.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                       :disabled="is_disabled_customer_fields">
                               <template v-slot:option="option">
                                 <span>{{option.name}} </span>
                               </template>
                             </v-select>
                             <span class="text-danger text-sm">{{ errors[0] }}</span>
                           </ValidationProvider>
                         </div>
                       </div>

                     </vx-card-custom>
                   </vs-col>
                 </vs-row>
                 <vs-button v-if="['sole_trader', 'partnership'].includes(form.type_of_company)" class="mt-4 mb-4 ml-4" @click="addSolePartnership" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus"
                            :disabled="is_disabled_customer_fields">
                   {{form.type_of_company === 'partnership' ? "Add another partner into your account" : "Add another sole trader into your account"}}
                 </vs-button>
                 <!--        solo partnership section end-->




                 <!--        <vs-divider class="mt-8 mb-12" color="primary" position="center">Trade Reference</vs-divider>-->

                 <!--        trade ref section start-->
                 <vx-card  titleColor="#736F6E" title="Trade Reference" class="my-8" no-shadow>
                   <vs-row vs-w="12" class="mt-8">
                     <vs-col v-for="(trade, index_address) in form.trade_reference" :key="index_address"
                             vs-type="flex"
                             vs-justify="center"
                             vs-align="center"
                             vs-lg="6" vs-sm="6" vs-xs="12"
                             class="px-4 pb-4">
                       <vx-card-custom :cardBorder="true" no-shadow  v-on:remove="deleteTradeRef(index_address)" :remove-card-action="form.trade_reference.length > 2 || !is_disabled_customer_fields"  :collapse-action="false">

                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-full w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'trade_reference_name'" :name="index_address+'trade_reference_name'" rules="" v-slot="{ errors }">
                               <small class="label">Reference Name</small>
                               <vs-input type="text" v-model="trade.reference_name" name="reference_name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'trade_line1'" :name="index_address+'trade_line1'" rules="" v-slot="{ errors }">
                               <small class="label">Address Line 1</small>
                               <vs-input type="text" v-model="trade.line1" name="line1" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'trade_line2'" :name="index_address+'trade_line2'" rules="" v-slot="{ errors }">
                               <small class="label">Address Line 2</small>
                               <vs-input type="text" v-model="trade.line2" name="line2" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'trade_line3'" :name="index_address+'trade_line3'" rules="" v-slot="{ errors }">
                               <small class="label">Address Line 3</small>
                               <vs-input type="text" v-model="trade.line3" name="line3" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'trade_town_state'" :name="index_address+'trade_town_state'" rules="" v-slot="{ errors }">
                               <small class="label">Name of Town / State</small>
                               <vs-input type="text" v-model="trade.town_state" name="town_state" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'trade_post_code'" :name="index_address+'trade_post_code'" rules="" v-slot="{ errors }">
                               <small class="label">Postal code</small>
                               <vs-input type="text" v-model="trade.post_code" name="post_code" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider :vid="index_address+'trade_country'" :name="index_address+'trade_country'" rules="" v-slot="{ errors }">
                               <small class="label">Country</small>
                               <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="trade.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                         :disabled="is_disabled_customer_fields">
                                 <template v-slot:option="option">
                                   <span>{{option.name}} </span>
                                 </template>
                               </v-select>
                               <span class="text-danger text-sm">{{ errors[0] }}</span>
                             </ValidationProvider>
                           </div>
                         </div>

                         <div class="vx-row mb-2">
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'trade_contact_name'" :name="index_address+'trade_contact_name'" rules="" v-slot="{ errors }">
                               <small class="label">Contact Name</small>
                               <vs-input type="text" v-model="trade.contact_name" name="contact_name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                           <div class="vx-col md:w-1/2 w-full md:mb-0">
                             <ValidationProvider  :vid="index_address+'trade_email'" :name="index_address+'trade_email'" rules="email" v-slot="{ errors }">
                               <small class="label">Email</small>
                               <vs-input type="text" v-model="trade.email" name="email" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"
                                         :disabled="is_disabled_customer_fields"/>
                             </ValidationProvider>
                           </div>
                         </div>

                       </vx-card-custom>
                     </vs-col>
                   </vs-row>
                   <vs-button class="mt-4 mb-4 ml-4" @click="addTradeRef" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus"
                              :disabled="is_disabled_customer_fields">Add trade reference</vs-button>
                 </vx-card>
                 <!--        trade ref section end-->


                 <!-- <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/5 w-full md:mb-0">
                     <small class="label">Upload Letter Head</small>
                     <file-uploader v-on:onSetFileName="value => form.letter_head = value" v-on:onClickFileRemove="form.letter_head = null" :file="form.letter_head" :condition="true"/>
                   </div>
                 </div> -->

                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-full w-full md:mb-0">
                     <ValidationProvider  vid="note" name="note" rules="" v-slot="{ errors }">
                       <small class="label">Any Note About Customer</small>
                       <vs-textarea  class="mb-0" v-model="form.note" :disabled="is_disabled_customer_fields"/>
                     </ValidationProvider>
                   </div>
                 </div>




                 <!-- Save & Reset Button -->
                 <div class="flex flex-wrap items-center justify-end">
                   <vs-button v-if="$canAny(customer_permissions)"
                     @click.stop="onClickUpdateProfile" class="ml-auto mt-2">Save Changes</vs-button>
                   <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
                 </div>
               </vx-card>
             </form>
           </ValidationObserver>
         </vs-tab>
         <vs-tab v-on:click="onClickTab()" label="Sage" v-if="$canAny(['view-sage-customer',' create-edit-sage-customer']) && !!form.status && [7, 9, 10, 11, 12].includes(form.status.id)">
           <vx-card id="customer_profile" class="">

             <div v-if="form.sage_id" class="vx-row">
               Sage id: {{ sage_customer_details.id }} <br>
               Sage ref: {{ sage_customer_details.reference }} <br>
             </div>

             <!-- Medium -->
             <div class="flex items-center justify-center mb-4">
               <button
                 v-can="'create-edit-sage-customer'"
                 v-if="form.sage_id"
                 @click="onClickUnlickSageCustomerConfirm()"
                 class="cursor-pointer text-primary bg-transparent border-l border-t border-b border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 rounded-l outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                 type="button">
                 Unlink existing customer
               </button>
               <button
                 v-can="'create-edit-sage-customer'"
                 v-if="!form.sage_id"
                 @click="onClickCreateSageCustomer()"
                 class="cursor-pointer text-primary bg-transparent border-l border-t border-b border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 rounded-l outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                 type="button">
                 Create new sage customer
               </button>
               <button
                 v-can="'create-edit-sage-customer'"
                 v-if="!form.sage_id"
                 @click="onClickLinkSageCustomer()"
                 class="cursor-pointer text-primary bg-transparent border border-solid border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                 type="button">
                 Link to existing customer
               </button>
               <button
                 id="customer-sage-sync-button"
                 v-if="form.sage_id"
                 v-can="'create-edit-sage-customer'"
                 @click="onClickUpdateSageCustomer()"
                 class="cursor-pointer text-primary bg-transparent border border-solid border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                 type="button">
                 Synchronise data with sage
               </button>
             </div>

           </vx-card>
         </vs-tab>
       </vs-tabs>
     </div>
   </div>
  <create-sage-customer-pop-up ref="createSageCustomerPopUp"/>
  <link-sage-customer-pop-up ref="linkSageCustomerPopUp"/>
 </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import SageFactory from '@/mixins/SageFactory';
  import vSelect from 'vue-select'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SageRepository = RepositoryFactory.get('sage')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  const PackSizeRepository = RepositoryFactory.get('pack_size')
  const CustomerSourceRepository = RepositoryFactory.get('customer_source')

  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import FileUploader from '@/components/shared/FileUploader'
  import CreateSageCustomerPopUp from "@/components/popups/customer/sage/CreateSageCustomerPopUp.vue";
  import LinkSageCustomerPopUp from "@/components/popups/customer/sage/LinkSageCustomerPopUp";
  import { mapActions, mapGetters } from "vuex";
  import SageHelper from '@/mixins/SageHelper'
  import { updateSageCustomer } from '@/services/SageService'
  import Utils from '@/mixins/Utils'
  
  function initialState() {
    return {
        contacts_types: [
          {name: 'Purchasing', value: 'purchasing'},
          {name: 'Accounts Payable', value: 'account_payable'},
          {name: 'Booking In', value: 'booking_in'},
          {name: 'Export Operations', value: 'export_operations'},
          {name: 'Technical/QC', value: 'technical_qc'},
          {name: 'NPD', value: 'npd'},
          {name: 'Emergency', value: 'emergency'},
          {name: 'Commercial', value: 'commercial'}
        ],
        company_types: [
          {name: 'Limited', value: 'limited'},
          {name: 'Sole Trader', value: 'sole_trader'},
          {name: 'Partnership', value: 'partnership'},
          {name: 'Public Service', value: 'public_service'},
          {name: 'Charity', value: 'charity'}
        ],
        sage_customer_details: {},
        form: {
          is_vat_registration: false,
          is_registration: false,
          invoice_address_same_as_above: false,
          invoice_address: [],

          addresses: [],
          parent_company_name: '',
          country_code_main_telephone: '',
          main_telephone: '',
          country_code_secondary_telephone: '',
          secondary_telephone: '',
          country_code_fax: '',
          fax: '',
          website: '',
          email: '',
          alternative_email: '',
          industry_sector: '',
          industry_sub_sector: '',
          source: [],
          sub_source: [],
          social_accounts: [],
          account_handler_id: '',
          background_info: '',
          value_added_activities: '',
          initial_enquiry: '',
          type_of_company: '',
          sole_partnerships: [],
          is_vat_registration_country: '',
          is_vat_registration_text: '',
          is_registration_country: '',
          is_registration_text: '',
          eori: '',
          tss_registration_number: '',
          nature_of_business: '',
          date_trade_commenced: '',
          credit_required_per_month: '',
          contacts: [],
          special_delivery_instruction: '',
          additional_information: '',
          bank: '',
          bank_address: {},
          trade_reference: [],
          letter_head: '',
          note: '',
          status: {name: ''},
          pack_sizes: [],
          payment_terms: '',
          stage: '',
          import_licence_no: '',
          ukims: '',
        },
        pack_sizes: [
            { formulation_type: 'powder', size: null },
            { formulation_type: 'liquid', size: null },
            { formulation_type: 'spray dry powder', size: null },
            { formulation_type: 'fruit', size: null }
        ],
        pack_size_options: [],
        countryCodes: [],
        customerId: '',
        industrySectors: [],
        industrySubSectors: [],
        industrySectorsAndSUbSectors: [],
        socialMediaList: ['Facebook', 'Twitter', 'LinkedIn', 'Pinterest', 'Reddit', 'Instagram'],
        customer_users: [],
        customerSources: [],
        customerSubSources: [],
    }
  }
  export default {
    mixins: [SuccessMessage, ErrorMessages, SageFactory, SageHelper, Utils],
    name: 'CustomerProfileDetailsView',
    data () {
      return initialState()
    },
    components: {
      LinkSageCustomerPopUp,
      'v-select': vSelect,
      Datepicker,
      flatPickr,
      FileUploader,
      CreateSageCustomerPopUp,
    },
    computed: {
      ...mapGetters([ 'account_handlers' ]),
      isSmallerScreen () {
        return false
      },
      customer_permissions: function () {
        if(this.form.stage === 'customer') {
          return ['create-edit-customer']
        } else {
          return ['create-edit-customer', 'sales-crm-access']
        }
      },
      is_disabled_customer_fields: function () {
        return !this.$canAny(this.customer_permissions)
      }
    },
    methods: {
      ...mapActions([ 'fetchAccountHandlers' ]),
      async onClickUpdateProfile() {

        if(['customer'].includes(this.form.stage)) {
          const validated = await this.$refs.form.validate().then((x) =>{
            return x
          })
          if(validated) {
            await this.formSubmission()
          }
        } else {
          await this.formSubmission()
        }
      },
      async formSubmission() {

        this.$vs.loading();
        try {
          this.form.is_vat_registration =  this.form.is_vat_registration ? this.form.is_vat_registration : false
          this.form.is_registration =  this.form.is_registration ? this.form.is_registration : false

          // this.form.delivery_address_same_as_above =  this.form.delivery_address_same_as_above ? this.form.delivery_address_same_as_above : false
          this.form.invoice_address_same_as_above =  this.form.invoice_address_same_as_above ? this.form.invoice_address_same_as_above : false

          // this.form.delivery_address =  this.form.delivery_address_same_as_above ? [] : this.form.delivery_address
          // if(this.form.invoice_address_same_as_above) {
          //   this.form.invoice_address = this.invoice_address
          // } else {
          //   this.form.invoice_address = this.invoice_address
          // }

          this.form.trade_reference = this.form.trade_reference.map((x) => {
            delete x.created_at
            delete x.updated_at
            delete x.customer_id
            delete x.id
            return x
          })


          if (!['sole_trader', 'partnership'].includes(this.form.type_of_company)) {
            this.form.sole_partnerships = []
          }
          this.form.pack_size = Number(this.form.pack_size).toFixed(4)
          const change = await CustomerRepository.updateCustomerDetails(this.customerId, this.form);
          await this.fetchCustomerUsers()
          await this.loadCustomerDetails()
          this.showSuccessMessage('Customer Profile Updated Successfully!')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      addMainAddress() {
        this.form.addresses.push({line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', type: 'main', note: ''})
      },
      deleteMainAddresses(index) {
        this.form.addresses.splice(index, 1)
      },
      addInvoiceAddress() {
        this.form.invoice_address.push({line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', type: 'invoice', note: ''})
      },
      deleteInvoiceAddresses(index) {
        this.form.invoice_address.splice(index, 1)
      },
      addDeliveryAddress() {
        this.form.delivery_address.push({line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', type: 'delivery', note: ''})
      },
      deleteDeliveryAddresses(index) {
        this.form.delivery_address.splice(index, 1)
      },
      initialContactsAdd() {
        this.form.contacts = [
          {contact_name: '', country_code_telephone: '', telephone: '', email: '', type: 'purchasing'},
        ]
      },
      async addToUsers(contact) {
        try {
          await CustomerRepository.createCustomerUser({
            customer_id: contact.customer_id,
            first_name: contact.contact_name,
            last_name: '-',
            email: contact.email,
            country_code_main_telephone: contact.country_code_telephone || '',
            main_telephone: contact.telephone || '',
            role_id: 8,
            employment_history: []
          })
          // if(!!this.form.sage_id && contact.type === 'account_payable') {
          //   await this.createCustomerSageContact(this.form.sage_id, contact)
          // }
          await this.fetchCustomerUsers()
          this.showSuccessMessage('Customer user created successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      isExsistInUsers(email) {
        return !!this.customer_users.find((x) => x.email === email)
      },
      addContact() {
        this.form.contacts.push({contact_name: '', country_code_telephone: '', telephone: '', email: '', type: 'purchasing'},)
      },
      deleteContact(index) {
        this.form.contacts.splice(index, 1)
      },
      addSolePartnership() {
        this.form.sole_partnerships.push({full_name: '', line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', country_code_telephone: '', telephone: ''})
      },
      deleteSolePartnership(index) {
        this.form.sole_partnerships.splice(index, 1)
      },
      addTradeRef() {
        this.form.trade_reference.push({reference_name: '', line1: '', line2: '', line3: '', town_state: '', post_code: '', country: '', contact_name: '', email: ''})
      },
      deleteTradeRef(index) {
        this.form.trade_reference.splice(index, 1)
      },
      addSocialAccount() {
        this.form.social_accounts.push({type: '', url: ''})
      },
      deleteSocialAccount(index) {
        this.form.social_accounts.splice(index, 1)
      },
      customerStatusChangeConfirmDialog (status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Confirm',
          text: 'Are you sure you wish to change this Customer’s status?',
          accept: this.changeCustomerStatus,
          parameters: [status]
        })
      },
      async changeCustomerStatus(params) {
        this.$vs.loading({
          container: '#customer_profile',
          scale: 0.50
        })
        try {
          await CustomerRepository.changeCustomerStatus(this.form.id, params[0])
          await this.reloadStatus()
          this.$emit('refreshData')
          this.showSuccessMessage('Customer status updated!')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#customer_profile > .con-vs-loading')
      },
      async reloadStatus() {
        const {data} = (await CustomerRepository.getCustomerDetails(this.customerId)).data
        this.form.status_id = data.status_id;
        this.form.status = data.status;
        this.form.is_customer_activated = data.is_customer_activated;
        this.form.stage = data.stage;
      },
      async loadIndustrySectors() {
        const {data} =  (await CustomerRepository.getIndustrySectors()).data
        this.industrySectors =  data
      },
      async fetchPackSizeList() {
        const { data } = (await PackSizeRepository.getListOfPackSize(1, '')).data
        this.pack_size_options = data
      },
      async loadAllIndustrySectorsAndSubSectors() {
        const {data} =  (await CustomerRepository.getIndustrySectorsAndSubSectors()).data
        this.industrySectorsAndSUbSectors =  data
      },
      async onChangeIndustrySector(ids) {
        await this.$vs.loading();
        try {
          this.form.industry_sub_sector = []
          if (ids.length > 0) {
            const {data} =  (await CustomerRepository.getIndustrySubSectors({ ids: ids })).data
            this.industrySubSectors =  data
          }
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        await this.$vs.loading.close()
      },
      async loadCustomerDetails() {
        try {
          const {data} = (await CustomerRepository.getCustomerDetails(this.customerId)).data;
          this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
          this.form = data;

          if (this.form.addresses.length === 0) {
            this.addMainAddress()
          }
          if (this.form.invoice_address.length === 0) {
            this.addInvoiceAddress()
          }
          // if (this.form.delivery_address.length === 0) {
          //   this.addDeliveryAddress()
          // }
          // if (this.form.contacts.length === 0) {
          //   this.initialContactsAdd()
          // }
          if (this.form.sole_partnerships.length === 0) {
            this.addSolePartnership()
          }
          if (this.form.bank_address.length === 0) {
            this.form.bank_address = {}
          }
          if (this.form.trade_reference.length === 0) {
            this.addTradeRef()
          }
          if (this.form.social_accounts.length === 0) {
            // this.addSocialAccount()
          }
          if(this.form.industry_sub_sector.length !== 0) {
            this.industrySubSectors = this.industrySectorsAndSUbSectors.filter((x) => this.form.industry_sub_sector.includes(x.id))
          }
          if(this.form.industry_sector.length !== 0) {
            const { data } =  (await CustomerRepository.getIndustrySubSectors({ ids: this.form.industry_sector })).data
            this.industrySubSectors =  data
          }
          if (this.form.sub_source.length !== 0) {
            const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: this.form.source })).data
            this.customerSubSources = data
          }
          if(!this.form.pack_sizes || this.form.pack_sizes.length === 0) {
            this.form.pack_sizes = this.pack_sizes
          }

        } catch (e) {

        }
      },
      setPlace(place, index) {
        for (const component of place.address_components) {
          const componentType = component.types[0];

          switch (componentType) {
            case "street_number": {
              this.form.addresses[index].line1 = `${component.long_name} ${this.form.addresses[index].line1}`;
              break;
            }

            case "route": {
              this.form.addresses[index].line1 += component.short_name;
              break;
            }

            case "postal_code": {
              this.form.addresses[index].post_code = `${component.long_name}${this.form.addresses[index].post_code}`;
              break;
            }

            case "postal_code_suffix": {
              this.form.addresses[index].post_code = `${this.form.addresses[index].post_code}-${component.long_name}`;
              break;
            }
            case "locality":
              this.form.addresses[index].line2 = component.long_name;
              break;

            case "administrative_area_level_1": {
              this.form.addresses[index].town_state = component.short_name;
              break;
            }
            case "country":
              this.form.addresses[index].country = component.long_name;
              break;
          }
        }
      },
      async onClickLinkSageCustomer() {
        await this.$refs.linkSageCustomerPopUp.openPopup(this.customerId, this.form.company_name)
      },
      async onClickUpdateSageCustomer() {
        await this.$vs.loading({
          container: '#customer-sage-sync-button',
          scale: 0.45
        })
        try {
          await updateSageCustomer(this.form, this.industrySectors)
          this.showSuccessMessage('Sage data synchronization successful!')
        } catch (e) {
          this.sageAuthHandler(e.response.status)
        }
        this.$vs.loading.close('#customer-sage-sync-button > .con-vs-loading')
      },
      async onClickUnlickSageCustomerConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Warning',
          acceptText: 'Proceed',
          text: 'You are about to unpair a nimble customer with Sage. This means that future transactions in sage will not show in this account. Are you sure you wish to proceed?',
          accept: this.onClickUnlickSageCustomer,
          cancel: null
        })
      },
      async onClickUnlickSageCustomer() {
        this.$vs.loading();
        try {
          await SageRepository.unLinkSageCustomer(this.customerId, { sage_id: this.form.sage_id })
          await this.loadCustomerDetails()
        } catch (e) {

        }
        this.$vs.loading.close();
      },
      async onClickCreateSageCustomer() {
        await this.$refs.createSageCustomerPopUp.openPopup(this.customerId, this.form, this.industrySectors)
      },
      async fetchSageSupplierDetails() {
        try {
          const { data } = (await SageRepository.getSageCustomerDetails(this.form.sage_id)).data
          this.sage_customer_details = data
        } catch(e) {
          this.sageAuthHandler(e.response.status)
        }
      },
      async onClickTab() {
        if(!!this.form.sage_id) {
          await this.fetchSageSupplierDetails()
        }
      },
      async fetchCustomerUsers() {
        try {
          const { data } = await CustomerRepository.getCustomerUsers(this.customerId, 1, '', 50, '')
          this.customer_users =  data.data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async loadCustomerSources() {
        const { data } = (await CustomerSourceRepository.getListOfCustomerSource()).data
        this.customerSources = data
      },
      async onChangeCustomerSource(ids) {
        this.$vs.loading({
          container: '#customer_profile',
          scale: 0.50
        })
          try {
            this.form.sub_source = []
            const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: ids })).data
            this.customerSubSources = data
          } catch (e) {
              this.convertAndNotifyError(e)
          }
        this.$vs.loading.close('#customer_profile > .con-vs-loading')
      },
    },
    async mounted() {
      this.customerId = this.$route.params.id
      await this.$vs.loading({
        container: '#customer-profile-details',
        scale: 0.45
      })
      await this.fetchAccountHandlers()
      await this.loadIndustrySectors()
      await this.loadAllIndustrySectorsAndSubSectors()
      await this.fetchCustomerUsers()
      await this.fetchPackSizeList()
      await this.loadCustomerDetails()
      await this.loadCustomerSources()
      this.$vs.loading.close('#customer-profile-details > .con-vs-loading')

    }
  }
</script>


<style lang="scss">
#customer-profile-tabs {
  width: 100%;
  .vs-tabs--ul {
    display: flex;
  }
  .vs-tabs-position-bottom .vs-tabs--ul, .vs-tabs-position-top .vs-tabs--ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap !important;
    justify-content: space-evenly;
  }

  .vs-tabs--li {
    flex-grow: 1 !important;
  }

  .line-vs-tabs {
    display: none;
  }

  .vs-tabs--li.activeChild {
    border-width: 0 0 2px 0;
    border-color: transparent;
    border-style:solid;
  }
}
</style>
